<textarea
    *ngIf="field.input.type === inputType.MULTISELECT || field.input.type === inputType.MULTISELECT_SEARCH; else readOnlyText"
    class="form-control"
    rows="3"
    [value]="displayValue"
    readonly>
</textarea>

<ng-template #readOnlyText>
    <p class="read-only">{{ displayValue }}</p>
</ng-template>
